import React, { useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import Discount from '@components/Discount';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import type { CustomerFormProps } from '../types';

const CustomerForm: React.FC<CustomerFormProps> = ({
    details,
    showGstField,
    onChange,
    onDiscountChange,
}) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="posv2-cart__customer">
            <button
                type="button"
                className="posv2-cart__customer-toggle"
                onClick={() => setExpanded((e) => !e)}
            >
                {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                <span>Customer & billing</span>
            </button>
            {expanded && (
                <>
                    <div className="posv2-cart__customer-grid">
                        <div className="posv2-cart__field">
                            <OutlinedInput
                                size="small"
                                fullWidth
                                type="number"
                                placeholder="Phone"
                                value={details.customerPhone}
                                onChange={(e) => onChange('customerPhone', e.target.value)}
                            />
                        </div>
                        <div className="posv2-cart__field">
                            <Discount size="small" fullWidth onChange={onDiscountChange} />
                        </div>
                    </div>

                    <div className="posv2-cart__customer-grid">
                        <div className="posv2-cart__field">
                            <OutlinedInput
                                size="small"
                                fullWidth
                                type="text"
                                placeholder="Name"
                                value={details.customerName}
                                onChange={(e) => {
                                    onChange('customerName', e.target.value);
                                    onChange('billingName', e.target.value);
                                }}
                            />
                        </div>
                        {showGstField && (
                            <div className="posv2-cart__field">
                                <OutlinedInput
                                    size="small"
                                    fullWidth
                                    type="text"
                                    placeholder="GSTIN"
                                    value={details.gstNumber}
                                    onChange={(e) => onChange('gstNumber', e.target.value)}
                                />
                            </div>
                        )}
                    </div>

                    <div className="posv2-cart__field posv2-cart__field--full">
                        <OutlinedInput
                            size="small"
                            fullWidth
                            type="text"
                            placeholder="Billing address"
                            value={details.billingAddress}
                            onChange={(e) => onChange('billingAddress', e.target.value)}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default React.memo(CustomerForm);
